var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-info",on:{"click":function($event){$event.preventDefault();return _vm.add()}}},[_c('i',{staticClass:"fa fa-fw fa-plus"}),_vm._t("default",[_vm._v("Dodaj wiersz")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }